import Services from "./Services";
import { createSportsAccountTransport } from "./_helpers/sportsAccountTransport";
import { captureSportsnewAccountCarrier } from "./_helpers/sportsnewAccountCarrier";

/** 스포츠 유저 API 서비스 */
export class SportsService extends Services {
  constructor(init) {
    super(init);
    this._name = "SPORTS";
    const transport = createSportsAccountTransport();
    this.accountAxios = transport.client;
    this.accountRequest = transport.request;
    return this;
  }

  normalizeInplayBetPayload = (data = {}) => ({
    ...data,
    selections: Array.isArray(data?.selections)
      ? data.selections.map((selection) => ({
          ...selection,
          inplay_odd_id: selection?.inplay_odd_id || selection?.odds_id || null,
        }))
      : [],
  });

  /* 종목/리그/경기 조회 (인증 불필요) */
  getCategories = async () =>
    await this.decorate(async () => await this.axios("/sports/categories", { method: "GET" }));

  getLeagues = async (sportSlug) =>
    await this.decorate(async () => await this.axios(`/sports/leagues/${sportSlug}`, { method: "GET" }));

  getMatches = async (params) =>
    await this.decorate(async () => await this.axios("/sports/matches", { method: "GET", params }));

  getMatchDetail = async (id, params = {}) =>
    await this.decorate(async () => await this.axios(`/sports/matches/${id}`, { method: "GET", params }));

  getMatchOdds = async (id, params = {}) =>
    await this.decorate(async () => await this.axios(`/sports/matches/${id}/odds`, { method: "GET", params }));

  /** 종목별 경기 수 */
  getMatchCounts = async (params) =>
    await this.decorate(async () => await this.axios("/sports/match-counts", { method: "GET", params }));

  /** 라이브 경기 수 */
  getLiveCount = async (params = {}) =>
    await this.decorate(async () => await this.axios("/sports/live-count", { method: "GET", params }));

  /** 베팅 취소 */
  cancelBet = async (id) =>
    await this.decorate(async () => await this.axios(`/sports/bets/${id}/cancel`, { method: "POST" }));

  capturePlacementAuthSessionCarrier = captureSportsnewAccountCarrier;

  /* 베팅 (인증 필수) */
  placeBet = async (data, { authSessionCarrier } = {}) =>
    await this.decorate(async () => await (authSessionCarrier
      ? this.accountRequest("/sports/bets", { method: "POST", data }, authSessionCarrier)
      : this.axios("/sports/bets", { method: "POST", data })));

  previewBet = async (data) =>
    await this.decorate(async () => await this.axios("/sports/bets/preview", { method: "POST", data }));

  placeInplayBet = async (data, { authSessionCarrier } = {}) =>
    await this.decorate(async () => {
      const config = { method: "POST", data: this.normalizeInplayBetPayload(data) };
      return await (authSessionCarrier
        ? this.accountRequest("/sports-inplay/bets", config, authSessionCarrier)
        : this.axios("/sports-inplay/bets", config));
    });

  /* 내 베팅 */
  getMyBets = async (params) =>
    await this.decorate(async () => await this.axios("/sports/my-bets", { method: "GET", params }));

  getMyBetDetail = async (id) =>
    await this.decorate(async () => await this.axios(`/sports/my-bets/${id}`, { method: "GET" }));

  /** fix75: 스포츠 활성 상태 조회 */
  getSportsStatus = async () =>
    await this.decorate(async () => await this.axios("/sports/status", { method: "GET" }));

  /** fix90: 조합 보너스 설정 조회 */
  getComboBonus = async () =>
    await this.decorate(async () => await this.axios("/sports/combo-bonus", { method: "GET" }));

  /** betting limits 조회 (level/user override aware) */
  getBettingLimits = async (params) =>
    await this.decorate(async () => await this.axios("/sports/betting-limits", { method: "GET", params }));

  /** display 설정 조회 */
  getDisplaySettings = async () =>
    await this.decorate(async () => await this.axios("/sports/display-settings", { method: "GET" }));
}

export default SportsService;
